// DEV MODE
//export const DEV_MODE = true;
export const DEV_MODE = false;

export const LOGIN_WITH_REDIRECT = false;







